const users = [
  {
    _id: "63d3245310249c43ca38804a",
    firstName: "John",
    lastName: "Smith",
    email: "johnsmith@gmail.com",
    password: "$2b$10$.3F/Zx6uD4iGFEXkj8/Mbeohp8PITsJid7oynAybKq545XzggRJe.",
    picturePath: "p11.webp",
    friends: [
      {
        _id: "63cae259ccea636a4d97d0b9",
        firstName: "Tessa",
        lastName: "Gray",
        occupation: "Journalist",
        location: "Los Angeles, CA",
        picturePath: "p7.webp",
      },
      {
        _id: "63cae259ccea636a4d97d0ba",
        firstName: "Xavier",
        lastName: "Woods",
        occupation: "Nurse",
        location: "Hamilton, ON",
        picturePath: "p8.webp",
      },
      {
        _id: "63cae259ccea636a4d97d0b8",
        firstName: "Cameron",
        lastName: "Bailey",
        occupation: "Event Planner",
        location: "Edmonton, AB",
        picturePath: "p5.webp",
      },
      {
        _id: "63cae259ccea636a4d97d0b5",
        firstName: "Lila",
        lastName: "Fernandez",
        occupation: "Artist",
        location: "Montreal, QC",
        picturePath: "p3.webp",
      },
    ],
    location: "Toronto, ON",
    occupation: "Developer",
    viewedProfile: 23,
    impressions: 5127,
    createdAt: "2023-01-27T01:09:39.640Z",
    updatedAt: "2023-02-15T03:00:07.134Z",
  },
  {
    _id: "63cae259ccea636a4d97d0b9",
    firstName: "Tessa",
    lastName: "Gray",
    occupation: "Journalist",
    location: "Los Angeles, CA",
    picturePath: "p7.webp",
    friends: [
      {
        _id: "63d3245310249c43ca38804a",
        firstName: "John",
        lastName: "Smith",
        email: "johnsmith@gmail.com",
        picturePath: "p11.webp",
        location: "Toronto, ON",
        occupation: "Developer",
      },
      {
        _id: "63cae259ccea636a4d97d0ba",
        firstName: "Xavier",
        lastName: "Woods",
        occupation: "Nurse",
        location: "Hamilton, ON",
        picturePath: "p8.webp",
      },
    ],
  },
  {
    _id: "63cae259ccea636a4d97d0ba",
    firstName: "Xavier",
    lastName: "Woods",
    occupation: "Nurse",
    location: "Hamilton, ON",
    picturePath: "p8.webp",
    friends: [
      {
        _id: "63d3245310249c43ca38804a",
        firstName: "John",
        lastName: "Smith",
        email: "johnsmith@gmail.com",
        picturePath: "p11.webp",
        location: "Toronto, ON",
        occupation: "Developer",
      },
      {
        _id: "63cae259ccea636a4d97d0b9",
        firstName: "Tessa",
        lastName: "Gray",
        occupation: "Journalist",
        location: "Los Angeles, CA",
        picturePath: "p7.webp",
      },
    ],
  },
  {
    _id: "63cae259ccea636a4d97d0b8",
    firstName: "Cameron",
    lastName: "Bailey",
    occupation: "Event Planner",
    location: "Edmonton, AB",
    picturePath: "p5.webp",
    friends: [
      {
        _id: "63d3245310249c43ca38804a",
        firstName: "John",
        lastName: "Smith",
        email: "johnsmith@gmail.com",
        picturePath: "p11.webp",
        location: "Toronto, ON",
        occupation: "Developer",
      },
      {
        _id: "63cae259ccea636a4d97d0b5",
        firstName: "Lila",
        lastName: "Fernandez",
        occupation: "Artist",
        location: "Montreal, QC",
        picturePath: "p3.webp",
      },
      {
        _id: "63cae259ccea636a4d97d0b7",
        firstName: "Avery",
        lastName: "Johnson",
        occupation: "Educator",
        location: "Calgary, AB",
        picturePath: "p6.webp",
      },
    ],
  },
  {
    _id: "63cae259ccea636a4d97d0b5",
    firstName: "Lila",
    lastName: "Fernandez",
    occupation: "Artist",
    location: "Montreal, QC",
    picturePath: "p3.webp",
    friends: [
      {
        _id: "63d3245310249c43ca38804a",
        firstName: "John",
        lastName: "Smith",
        email: "johnsmith@gmail.com",
        picturePath: "p11.webp",
        location: "Toronto, ON",
        occupation: "Developer",
      },
      {
        _id: "63cae259ccea636a4d97d0b8",
        firstName: "Cameron",
        lastName: "Bailey",
        occupation: "Event Planner",
        location: "Edmonton, AB",
        picturePath: "p5.webp",
      },
      {
        _id: "63cae259ccea636a4d97d0bb",
        firstName: "Jessica",
        lastName: "Dunn",
        occupation: "Student",
        location: "Washington, DC",
        picturePath: "p9.webp",
        friends: [],
      },
    ],
  },
  {
    _id: "63cae259ccea636a4d97d0b7",
    firstName: "Avery",
    lastName: "Johnson",
    occupation: "Educator",
    location: "Calgary, AB",
    picturePath: "p6.webp",
    friends: [
      {
        _id: "63cae259ccea636a4d97d0b8",
        firstName: "Cameron",
        lastName: "Bailey",
        occupation: "Event Planner",
        location: "Edmonton, AB",
        picturePath: "p5.webp",
      },
    ],
  },
  {
    _id: "63cae259ccea636a4d97d0bb",
    firstName: "Jessica",
    lastName: "Dunn",
    occupation: "Student",
    location: "Washington, DC",
    picturePath: "p9.webp",
    friends: [
      {
        _id: "63cae259ccea636a4d97d0b5",
        firstName: "Lila",
        lastName: "Fernandez",
        occupation: "Artist",
        location: "Montreal, QC",
        picturePath: "p3.webp",
      },
    ],
  },
];

export default users;
